import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { BlockModel, UnitsModel } from '../../../models/units.model';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { EventService } from 'src/app/core/services/event.service';
import { DevelopmentsService } from '../../../services/developments.services';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { debounceTime, distinctUntilChanged, finalize, map, switchMap } from 'rxjs/operators';
import { PermissionsService } from 'src/app/core/services/permissions.service';

type InlineUnitField = 'propertyType' | 'price' | 'grossArea' | 'bedrooms' | 'bathrooms' | 'floor';

@Component({
  selector: 'app-units',
  templateUrl: './units.component.html',
  styleUrls: ['./units.component.scss']
})
export class UnitsComponent implements OnInit, AfterViewInit, OnDestroy {
  unitsSortField:
    | 'reference'
    | 'floor'
    | 'price'
    | 'grossArea'
    | 'bedrooms'
    | 'bathrooms'
    | null = null;
  unitsSortDirection: 'asc' | 'desc' = 'asc';

  dataBlocks: BlockModel[] = [];
  dataFractions: UnitsModel[] = [];
  queryField = new FormControl();
  @Input() propertyUpdate: any;
  @Input() propertyToPermission: any;
  @Input() unitsData: any;
  @Input() propertyTypes: any;
  @Input() checkAutoRef: any;
  @Input() langs!: any[];
  typeSelected: any;
  animateClass: number | null = null;
  developmentTypes: { id: number, tooltip: string, text: string, img: string }[] = [
    { id: 1, text: this.translateService.instant('t-developments.t-fraction-only'), tooltip: this.translateService.instant('t-developments.t-fraction-only-tooltip'), img: 'assets/icons/development-1.svg' },
    { id: 2, text: this.translateService.instant('t-developments.t-fraction-blocks'), tooltip: this.translateService.instant('t-developments.t-fraction-blocks-tooltip'), img: 'assets/icons/development-2.svg' },
  ]
  submited: boolean = false;
  blockForm!: FormGroup;
  fractionForm!: FormGroup;
  fractionQuantity: any = Array.from({ length: 100 }, (_, i) => i + 1);
  page: number = 1;
  pageSize: number = 10;
  startIndex: number = 1;
  unitsToShow: any = [];
  blockPages: Record<string, number> = {};
  openedDropdown!: number | null;
  subscriptions: Subscription = new Subscription();
  fractionUpdated!: UnitsModel | null;
  @Output() unitsDataChange = new EventEmitter<any>();
  blocksBkp: BlockModel[] = [];
  // no blocks
  noBlockFractions: UnitsModel[] = [];
  @ViewChild('blockContent', { static: true }) blockContent!: ElementRef;
  @ViewChildren(NgSelectComponent) ngSelects!: QueryList<NgSelectComponent>;
  loginUser!: { id?: string, role?: { id?: string, name?: string }, stores?: any[], associatedUsers?: any };

  // ─── Edição inline na tabela ─────────────────────────────────────────
  // Um clique numa célula (piso, tipo, preço, área, quartos, WC) abre o editor
  // no lugar; Enter/blur grava, Esc cancela. Frações gravadas vão ao servidor;
  // as novas ficam em memória até se gravar o empreendimento.
  inlineEdit: { unitId: any; field: InlineUnitField } | null = null;
  inlineEditValue: any = null;
  inlineSaving = false;
  private inlineCommitting = false;

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private eventService: EventService,
    private propertiesService: DevelopmentsService,
    public permissionsService: PermissionsService
  ) { }

  ngOnInit(): void {
    const { id, role, stores, associatedUsers } = this.propertiesService.getUserAuth();
    this.loginUser = { id, role, stores, associatedUsers };
    if (this.unitsData && this.unitsData?.length > 0) {
      if (this.unitsData[0]?.name) {
        this.typeSelected = this.developmentTypes[1];
        this.dataBlocks = this.unitsData?.map((block: any) => {
          return {
            ...block,
            units: block?.units?.map((fraction: any) => {
              return {
                ...fraction,
                propertyTypeId: !fraction?.propertyTypeId ? fraction?.propertyType : fraction?.propertyTypeId,
                propertyType: !fraction?.propertyTypeId ? this.propertyTypes.find((pt: any) => pt.id == fraction.propertyType)?.description : fraction?.propertyType
              }
            })
          }
        });
        this.blocksBkp = [...this.dataBlocks]
      } else {
        this.typeSelected = this.developmentTypes[0];
        this.dataFractions = this.unitsData?.map((p: any) => {
          return {
            ...p,
            propertyTypeId: !p?.propertyTypeId ? p?.propertyType : p?.propertyTypeId,
            propertyType: !p?.propertyTypeId ? this.propertyTypes.find((pt: any) => pt.id == p.propertyType)?.description : p?.propertyType
          }
        });
        this.refreshPagination(this.dataFractions);
      }
    }
    const refreshSub = this.eventService.subscribe('refresh-dev-property', id => {
      if (id) {
        this.propertiesService.getUnitById(id).subscribe({
          next: data => {
            this.dataFractions = this.dataFractions.map(fraction => {
              if (fraction.id === id) {
                return {
                  ...data,
                  propertyTypeId: data?.propertyType,
                  propertyType: this.propertyTypes.find((pt: any) => pt.id == data.propertyType)?.description
                }
              } else {
                return fraction;
              }
            });
            this.dataBlocks = this.dataBlocks.map(block => {
              return {
                ...block,
                units: block.units?.map(fraction => {
                  if (fraction.id === id) {
                    return {
                      ...data,
                      propertyTypeId: data?.propertyType,
                      propertyType: this.propertyTypes.find((pt: any) => pt.id == data.propertyType)?.description
                    };
                  } else {
                    return fraction;
                  }
                })
              }
            });
            this.blocksBkp = this.blocksBkp.map(block => {
              return {
                ...block,
                units: block.units?.map(fraction => {
                  if (fraction.id === id) {
                    return {
                      ...data,
                      propertyTypeId: data?.propertyType,
                      propertyType: this.propertyTypes.find((pt: any) => pt.id == data.propertyType)?.description
                    };
                  } else {
                    return fraction;
                  }
                })
              }
            });
            if (this.typeSelected.id === 1) {
              this.refreshPagination(this.dataFractions);
            } else if (this.typeSelected.id === 2 && this.openedDropdown) {
              const find = this.dataBlocks.find(b => b.id === this.openedDropdown);
              if (find)
                this.refreshPagination(find.units);
            }
          }
        })
      }
    })
    const saveEvent = this.eventService.subscribe('get-data-tab-units', () => {
      if (this.typeSelected?.id === 1) {
        this.unitsData = this.dataFractions;
      } else if (this.typeSelected?.id === 2) {
        this.unitsData = this.dataBlocks;
      }
      this.unitsDataChange.emit(this.unitsData);
    })
    this.subscriptions.add(refreshSub);
    this.subscriptions.add(saveEvent);
    this.initSearch();
  }

  ngAfterViewInit(): void {
    this.propertyTypes = this.propertyTypes.filter((type: any) => !['Developments', 'Enterprises'].includes(type?.groupMainDescription));
  }

  initSearch() {
    this.queryField.valueChanges
      .pipe(
        map(value => value?.trim()),
        map(value => value?.toLowerCase()),
        //filter(value => value.length > 1),
        debounceTime(200),
        distinctUntilChanged(),
      ).subscribe(value => {
        if (this.typeSelected?.id === 1) {
          const data = this.dataFractions.filter(fraction => {
            return fraction.title.some(t => t.text.toLowerCase().includes(value)) || fraction.reference?.toLowerCase().includes(value) || fraction.propertyType?.toLowerCase()?.includes(value);
          })
          this.refreshPagination(data);
        } else if (this.typeSelected?.id === 2) {
          if (value) {
            this.dataBlocks = this.blocksBkp.filter(block => {
              return block.name?.toLowerCase().includes(value) || block?.units?.some(fraction => {
                return fraction.title.some(t => t.text.toLowerCase().includes(value)) || fraction.reference?.toLowerCase().includes(value) || fraction.propertyType?.toLowerCase()?.includes(value);
              })
            });
            this.dataBlocks = this.dataBlocks.map(block => {
              return {
                ...block,
                units: block.units.filter(fraction => {
                  return fraction.title.some(t => t.text.toLowerCase().includes(value)) || fraction.reference?.toLowerCase().includes(value) || fraction.propertyType?.toLowerCase()?.includes(value);
                })
              }
            })
            if (this.openedDropdown) {
              const find = this.dataBlocks.find(b => b.id == this.openedDropdown);
              if (find)
                this.refreshPagination(find?.units);
            }
          } else {
            this.dataBlocks = this.blocksBkp;
            if (this.openedDropdown) {
              const find = this.dataBlocks.find(b => b.id == this.openedDropdown);
              if (find)
                this.refreshPagination(find?.units);
            }
          }

        }
      });
  }

  openOrCloseDropdown(block: BlockModel) {
    const blockPage = this.getBlockPage(block);
    this.page = blockPage;
    this.startIndex = 1;
    if (this.openedDropdown && this.openedDropdown === block.id) {
      this.openedDropdown = null;
    } else {
      this.openedDropdown = block.id;
      this.refreshPagination(block.units || [], blockPage);
    }
  }

  refreshPagination(units: any[], pageOverride?: number) {
    const sortedUnits = this.getSortedUnits(units || []);
    const totalPages = Math.max(1, Math.ceil(sortedUnits.length / this.pageSize));
    const requestedPage = pageOverride ?? this.page;
    const safePage = Math.min(Math.max(requestedPage, 1), totalPages);
    this.page = safePage;
    const start = safePage === 1 ? 0 : (safePage - 1) * this.pageSize;
    this.startIndex = start;
    this.unitsToShow = sortedUnits.slice(start, start + this.pageSize);
  }

  getBlockPage(block: BlockModel) {
    return this.blockPages[String(block?.id)] ?? 1;
  }

  onBlockPageChange(block: BlockModel, page: number) {
    this.blockPages[String(block?.id)] = page;
    this.page = page;
    this.refreshPagination(block?.units || [], page);
  }

  onUnitsSort(
    field:
      | 'reference'
      | 'floor'
      | 'price'
      | 'grossArea'
      | 'bedrooms'
      | 'bathrooms',
    block?: BlockModel,
  ) {
    if (this.unitsSortField === field) {
      this.unitsSortDirection = this.unitsSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.unitsSortField = field;
      this.unitsSortDirection = 'asc';
    }

    this.page = 1;
    this.startIndex = 1;

    if (this.typeSelected?.id === 1) {
      this.refreshPagination(this.dataFractions);
      return;
    }

    if (this.typeSelected?.id === 2 && block) {
      this.refreshPagination(block.units || []);
      return;
    }

    if (this.typeSelected?.id === 2 && this.openedDropdown) {
      const opened = this.dataBlocks.find((b) => b.id === this.openedDropdown);
      if (opened) {
        this.refreshPagination(opened.units || []);
      }
    }
  }

  getUnitsSortIndicator(
    field:
      | 'reference'
      | 'floor'
      | 'price'
      | 'grossArea'
      | 'bedrooms'
      | 'bathrooms',
  ) {
    if (this.unitsSortField !== field) {
      return '↕';
    }
    return this.unitsSortDirection === 'asc' ? '↑' : '↓';
  }

  private getSortedUnits(units: UnitsModel[]) {
    if (!Array.isArray(units) || !this.unitsSortField) {
      return Array.isArray(units) ? [...units] : [];
    }

    const direction = this.unitsSortDirection === 'asc' ? 1 : -1;
    const field = this.unitsSortField;

    return [...units].sort((a, b) => {
      if (field === 'reference') {
        const referenceA = this.getUnitReferenceForSort(a);
        const referenceB = this.getUnitReferenceForSort(b);
        return (
          referenceA.localeCompare(referenceB, undefined, {
            numeric: true,
            sensitivity: 'base',
          }) * direction
        );
      }

      const valueA = this.getNumericSortableField(a, field);
      const valueB = this.getNumericSortableField(b, field);

      if (valueA === null && valueB === null) return 0;
      if (valueA === null) return 1;
      if (valueB === null) return -1;
      return (valueA - valueB) * direction;
    });
  }

  private getUnitReferenceForSort(unit: UnitsModel) {
    return String(unit?.reference ?? unit?.title?.[0]?.text ?? '').trim();
  }

  private getNumericSortableField(
    unit: UnitsModel,
    field: 'floor' | 'price' | 'grossArea' | 'bedrooms' | 'bathrooms',
  ): number | null {
    switch (field) {
      case 'floor':
        return this.parseSortNumber(unit?.floor);
      case 'price':
        return this.parseSortNumber(unit?.price);
      case 'grossArea':
        return this.parseSortNumber(unit?.grossArea);
      case 'bedrooms':
        return this.parseSortNumber(unit?.bedrooms);
      case 'bathrooms':
        return this.parseSortNumber(unit?.bathrooms);
      default:
        return null;
    }
  }

  private parseSortNumber(value: any): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : null;
    }

    const normalized = String(value).replace(/\s/g, '').replace(',', '.');
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : null;
  }

  get formBlock() {
    return this.blockForm.controls;
  }

  initFormBlock(name: any) {
    this.blockForm = this.formBuilder.group({
      name: [name, [Validators.required]]
    });
  }

  clearFormBlock() {
    this.blockForm.reset();
  }

  deleteBlock(block: BlockModel) {
    Swal.fire({
      title: this.translateService.instant('t-developments.t-delete-block-message'),
      //text: 'Deleting your user will remove all of your information from our database.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f46a6a',
      confirmButtonText: this.translateService.instant('t-yes'),
      cancelButtonText: this.translateService.instant('t-cancel')
    }).then(result => {
      if (result.value) {
        if (block.isNew) {
          this.dataBlocks = this.dataBlocks.filter(b => b.id !== block.id);
          this.blocksBkp = this.blocksBkp.filter(b => b.id !== block.id);

          if (this.typeSelected?.id === 2) {
            this.unitsData = this.blocksBkp;
            if (this.openedDropdown) {
              const block = this.blocksBkp.find(b => b.id === this.openedDropdown);
              if (block)
                this.refreshPagination(block.units);
            }
          }
          this.unitsDataChange.emit(this.unitsData);

          Swal.fire(
            this.translateService.instant('t-m-properties.t-deleted'),
            '',
            'success');
        } else {
          this.propertiesService.deleteBlock(block.id).subscribe(
            () => {
              this.dataBlocks = this.dataBlocks.filter(b => b.id !== block.id);
              this.blocksBkp = this.blocksBkp.filter(b => b.id !== block.id);

              if (this.typeSelected?.id === 2) {
                this.unitsData = this.blocksBkp;
                if (this.openedDropdown) {
                  const block = this.blocksBkp.find(b => b.id === this.openedDropdown);
                  if (block)
                    this.refreshPagination(block.units);
                }
              }
              this.unitsDataChange.emit(this.unitsData);

              Swal.fire(
                this.translateService.instant('t-m-properties.t-deleted'),
                '',
                'success');
            },
            error => {
              // console.error(error);
              this.errorMsg(this.translateService.instant('t-m-properties.t-at-the-moment-it-is-not-possible-to-delete-the-property'));
            }
          );
        }
      }
    });

  }

  submitNewBlock() {
    this.submited = true;
    if (this.blockForm.valid) {
      if (!this.dataBlocks.some(block => block.name === this.blockForm.get('name')?.value)) {
        this.dataBlocks.push({
          name: this.blockForm.get('name')?.value,
          id: 'new' + this.dataBlocks.length + 1,
          units: this.noBlockFractions ? this.noBlockFractions : [],
          isNew: true
        });
        this.blocksBkp.push({
          name: this.blockForm.get('name')?.value,
          id: 'new' + this.blocksBkp.length + 1,
          units: this.noBlockFractions ? this.noBlockFractions : [],
          isNew: true
        });
        if (this.noBlockFractions) {
          this.noBlockFractions = [];
        }
        this.submited = false;
        this.blockForm.reset();
        document.getElementById('block-dismiss-btn')?.click();
      } else {
        this.blockForm.get('name')?.setErrors({
          nameExists: true
        })
      }
    }
  }

  addBlock(content: any) {
    this.initFormBlock(null);
    let modal = this.modalService.open(content, { size: 'sm', centered: true, backdropClass: 'custom-modal' });
    if (this.noBlockFractions) {
      modal.closed.subscribe(() => {
        // setTimeout(() => {
        this.animateClass = null;
        this.typeSelected = this.noBlockFractions?.length > 0 ? this.developmentTypes[0] : this.developmentTypes[1];
        // }, 800);
      });
      modal.dismissed.subscribe(() => {
        // setTimeout(() => {
        this.animateClass = null;
        this.typeSelected = this.noBlockFractions?.length > 0 ? this.developmentTypes[0] : this.developmentTypes[1];
        // }, 800);
      });
    }
  }

  addFraction(content: any, id: any = null) {
    this.initFormFraction({ blockId: id });
    this.modalService.open(content, { size: 'md', centered: true, backdropClass: 'custom-modal' })
  }

  get formFraction() {
    return this.fractionForm.controls;
  }

  initFormFraction(data: any) {
    this.fractionForm = this.formBuilder.group({
      blockId: [data?.blockId],
      quantity: [1, [Validators.required]],
      // reference: [data?.reference ? data?.reference : this.propertyRef, [Validators.required]],
      floor: [data?.floor],
      propertyType: [data?.propertyType && !isNaN(Number(data?.propertyType)) ? data?.propertyType : data?.propertyTypeId, [Validators.required]],
      price: [data?.price],
      grossArea: [data?.grossArea],
      bedrooms: [data?.bedrooms ? data?.bedrooms : 0],
      bathrooms: [data?.bathrooms ? data?.bathrooms : 0],
      status: [data?.status == false ? false : true],
    });
  }

  clearFormFraction() {
    this.fractionForm.reset();
  }

  submitNewFraction() {
    this.submited = true;
    if (this.fractionForm.valid) {
      if (this.typeSelected.id === 1) {
        if (!this.fractionUpdated) {
          const quantity = this.fractionForm.get('quantity')?.value ? this.fractionForm.get('quantity')?.value : 1;
          for (let i = 0; i < Number(quantity); i++) {
            let pType = this.propertyTypes?.find((p: any) => p.id === this.fractionForm.get('propertyType')?.value);
            pType = pType && pType?.description ? pType?.description : this.translateService.instant('t-m-properties.t-fraction');
            const title = this.fractionForm.get('bedrooms')?.value ? this.translateService.instant('t-developments.t-generic-title', { type: pType, bedrooms: this.fractionForm.get('bedrooms')?.value }) : pType;
            const lang = this.langs?.find(l => l.lang == this.translateService.currentLang);
            const data = {
              ...this.fractionForm.value,
              propertyType: pType,
              propertyTypeId: this.fractionForm.get('propertyType')?.value,
              title: [{ text: title, lang: lang ? lang?.id : 0 }],
              id: this.createLocalFractionId(),
              quantity: undefined,
              // reference: quantity > 1 ? `${this.fractionForm.get('reference')?.value}-${i + 1}` : this.fractionForm.get('reference')?.value,
              isNew: true
            }
            this.dataFractions?.push(data);
          }
        } else {
          this.dataFractions = this.dataFractions.map(fraction => {
            if (fraction.id === this.fractionUpdated?.id) {
              let pType = this.propertyTypes?.find((p: any) => p.id === this.fractionForm.get('propertyType')?.value);
              pType = pType && pType?.description ? pType?.description : this.translateService.instant('t-m-properties.t-fraction');
              const title = this.fractionForm.get('bedrooms')?.value ? this.translateService.instant('t-developments.t-generic-title', { type: pType, bedrooms: this.fractionForm.get('bedrooms')?.value }) : pType;
              const lang = this.langs?.find(l => l.lang == this.translateService.currentLang);
              return {
                ...this.fractionForm.value,
                propertyType: pType,
                propertyTypeId: this.fractionForm.get('propertyType')?.value,
                title: [{ text: title, lang: lang ? lang?.id : 0 }],
                quantity: undefined,
                // reference: `${this.fractionForm.get('reference')?.value}`,
                // O formulario nao tem controlo `id`: sem isto a fracao ficava
                // sem id ao ser editada e deixava de casar na proxima edicao.
                id: fraction.id,
                isNew: true
              }
            } else {
              return fraction;
            }
          })
        }
        this.fractionForm.reset();
        this.refreshPagination(this.dataFractions);
        document.getElementById('block-dismiss-btn')?.click();
      } else if (this.typeSelected.id === 2) {
        const find: any = this.dataBlocks.find(b => b.id === this.fractionForm.get('blockId')?.value);
        if (find) {
          if (!this.fractionUpdated) {
            const quantity = this.fractionForm.get('quantity')?.value ? this.fractionForm.get('quantity')?.value : 1;
            for (let i = 0; i < Number(quantity); i++) {
              let pType = this.propertyTypes?.find((p: any) => p.id === this.fractionForm.get('propertyType')?.value);
              pType = pType && pType?.description ? pType?.description : this.translateService.instant('t-m-properties.t-fraction');
              const title = this.fractionForm.get('bedrooms')?.value ? this.translateService.instant('t-developments.t-generic-title', { type: pType, bedrooms: this.fractionForm.get('bedrooms')?.value }) : pType;
              const lang = this.langs?.find(l => l.lang == this.translateService.currentLang);
              const data = {
                ...this.fractionForm.value,
                propertyType: pType,
                propertyTypeId: this.fractionForm.get('propertyType')?.value,
                title: [{ text: title, lang: lang ? lang?.id : 0 }],
                id: this.createLocalFractionId(),
                quantity: undefined,
                // reference: quantity > 1 ? `${this.fractionForm.get('reference')?.value}-${i + 1}` : this.fractionForm.get('reference')?.value,
                isNew: true
              }
              find.units?.push(data);
            }
          } else {
            find.units = find.units?.map((fraction: any) => {
              if (fraction.id == this.fractionUpdated?.id) {
                let pType = this.propertyTypes?.find((p: any) => p.id === this.fractionForm.get('propertyType')?.value);
                pType = pType && pType?.description ? pType?.description : this.translateService.instant('t-m-properties.t-fraction');
                const title = this.fractionForm.get('bedrooms')?.value ? this.translateService.instant('t-developments.t-generic-title', { type: pType, bedrooms: this.fractionForm.get('bedrooms')?.value }) : pType;
                const lang = this.langs?.find(l => l.lang == this.translateService.currentLang);
                return {
                  ...this.fractionForm.value,
                  propertyType: pType,
                  propertyTypeId: this.fractionForm.get('propertyType')?.value,
                  title: [{ text: title, lang: lang ? lang?.id : 0 }],
                  quantity: undefined,
                  // reference: `${this.fractionForm.get('reference')?.value}`,
                  id: fraction.id,
                  isNew: true
                }
              } else {
                return fraction;
              }
            });
          }
          this.fractionUpdated = null;
          this.fractionForm.reset();
          this.refreshPagination(find?.units);
          document.getElementById('block-dismiss-btn')?.click();
        }
      }
      this.submited = false;
    }
  }

  priceFormat(propertyPrice: any) {
    if (propertyPrice) {
      let price = propertyPrice.toString().split('.');
      const spaces = (price: any) =>
        String(price).replace(/(?!^)(?=(?:\d{3})+$)/g, ' ');
      const price1 = spaces(price[0]);
      if (price.length > 1) return price1 + ',' + price[1];

      return price1;
    } return propertyPrice;
  }

  drop(event: CdkDragDrop<BlockModel[]> | any) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  selectType(type: any) {
    this.animateClass = type;
    this.queryField.reset();
    if (type?.id === 1) {
      if (this.blocksBkp.length > 0) {
        Swal.fire({
          title: this.translateService.instant('t-developments.t-change-format'),
          text: this.translateService.instant('t-developments.t-change-unit'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#f46a6a',
          confirmButtonText: this.translateService.instant('t-yes'),
          cancelButtonText: this.translateService.instant('t-cancel')
        }).then(result => {
          if (result.value) {
            const data: any[] = [];
            this.blocksBkp.forEach(b => b.units.forEach(u => data.push(u)));
            this.dataFractions = data;
            this.blocksBkp = this.blocksBkp.filter(b => !b.isNew);
            if (this.blocksBkp.length > 0) {
              this.propertiesService.deleteBlocks(this.blocksBkp.map(b => b.id)).subscribe(() => {
                this.blocksBkp = [];
                this.dataBlocks = [];
                // setTimeout(() => {
                this.animateClass = null;
                this.typeSelected = type;
                this.refreshPagination(this.dataFractions);
                // }, 800);
              })
            } else {
              setTimeout(() => {
                this.animateClass = null;
                this.typeSelected = type;
              }, 800);
            }
          } else {
            this.animateClass = null;
            this.typeSelected = this.developmentTypes[1];
          }
        });
      } else {
        setTimeout(() => {
          this.animateClass = null;
          this.typeSelected = type;
        }, 800);
      }
    } else if (type?.id === 2) {
      if (this.dataFractions.length > 0) {
        Swal.fire({
          title: this.translateService.instant('t-developments.t-change-format'),
          text: this.translateService.instant('t-developments.t-change-block'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#f46a6a',
          confirmButtonText: this.translateService.instant('t-yes'),
          cancelButtonText: this.translateService.instant('t-cancel')
        }).then(result => {
          if (result.value) {
            this.noBlockFractions = this.dataFractions;
            this.addBlock(this.blockContent);
            this.page = 1;
            this.startIndex = 1;
          } else {
            this.animateClass = null;
            this.typeSelected = this.developmentTypes[0];
          }
        });
      } else {
        setTimeout(() => {
          this.animateClass = null;
          this.typeSelected = type;
        }, 800);
      }

    }
  }

  increment(type: 'bathrooms' | 'bedrooms') {
    const val = this.fractionForm.get(type)?.value;
    if (val && val != 0) {
      this.fractionForm.get(type)?.setValue(val + 1);
    } else {
      this.fractionForm.get(type)?.setValue(1);
    }
  }

  decrement(type: 'bathrooms' | 'bedrooms') {
    const val = this.fractionForm.get(type)?.value;
    if (val && (val - 1) >= 0) {
      this.fractionForm.get(type)?.setValue(val - 1);
    } else {
      this.fractionForm.get(type)?.setValue(0);
    }
  }

  canManageUnit(unit?: UnitsModel) {
    return (
      this.loginUser.id === this.propertyUpdate?.mainAgent ||
      this.permissionsService.checkAgentPermission(unit?.mainAgent, 'EDIT_PROPERTIES') ||
      this.permissionsService.canEditProperty(this.loginUser, this.propertyToPermission?.store?.id) ||
      !this.propertyUpdate
    );
  }

  canInlineEdit(unit?: UnitsModel | any): boolean {
    return !!unit && !unit.isDuplicating && !this.inlineSaving && this.canManageUnit(unit);
  }

  isInlineEditing(unit: UnitsModel | any, field: InlineUnitField): boolean {
    return !!this.inlineEdit && this.inlineEdit.unitId === unit?.id && this.inlineEdit.field === field;
  }

  inlineEditorId(unit: UnitsModel | any, field: InlineUnitField): string {
    return `unit-inline-${field}-${unit?.id}`;
  }

  startInlineEdit(unit: UnitsModel | any, field: InlineUnitField, event?: Event) {
    event?.stopPropagation();
    if (!this.canInlineEdit(unit) || this.isInlineEditing(unit, field)) return;
    if (this.inlineEdit) this.cancelInlineEdit();

    this.inlineEdit = { unitId: unit.id, field };
    this.inlineEditValue = field === 'propertyType' ? unit.propertyTypeId ?? null : unit[field] ?? null;

    // O editor só existe depois da deteção de alterações: foca-o a seguir.
    const editorId = this.inlineEditorId(unit, field);
    setTimeout(() => {
      if (field === 'propertyType') {
        const select = this.ngSelects?.find(s => s.element?.id === editorId);
        select?.focus();
        select?.open();
        return;
      }
      const input = document.getElementById(editorId) as HTMLInputElement | null;
      input?.focus();
      input?.select?.();
    });
  }

  cancelInlineEdit() {
    this.inlineEdit = null;
    this.inlineEditValue = null;
  }

  onInlineKeydown(event: KeyboardEvent, unit: UnitsModel | any, block?: BlockModel) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.commitInlineEdit(unit, block);
    } else if (event.key === 'Escape') {
      event.preventDefault();
      this.cancelInlineEdit();
    }
  }

  commitInlineEdit(unit: UnitsModel | any, block?: BlockModel) {
    if (!this.inlineEdit || this.inlineEdit.unitId !== unit?.id || this.inlineCommitting) return;

    const field = this.inlineEdit.field;
    const value = this.normalizeInlineValue(field, this.inlineEditValue);
    // Valor inválido (ex.: texto no preço): descarta e mantém o que estava.
    if (value === undefined) {
      this.cancelInlineEdit();
      return;
    }

    const current = field === 'propertyType' ? unit.propertyTypeId : unit[field];
    if (this.isSameInlineValue(current, value)) {
      this.cancelInlineEdit();
      return;
    }

    if (!this.isPersistedFraction(unit)) {
      this.applyInlineValue(unit, field, value);
      this.cancelInlineEdit();
      this.syncUnitsDataToParent();
      return;
    }

    const payload: any = field === 'propertyType' ? { propertyTypeId: value } : { [field]: value };
    this.inlineCommitting = true;
    this.inlineSaving = true;
    this.propertiesService.updateUnitBasic(unit.id, payload)
      .pipe(finalize(() => {
        this.inlineSaving = false;
        this.inlineCommitting = false;
      }))
      .subscribe({
        next: (data: any) => {
          this.applyInlineValue(unit, field, value);
          // Piso/quartos/WC podem ter sido normalizados no servidor.
          if (data && typeof data === 'object') {
            if (field === 'floor' && data.floor !== undefined) unit.floor = data.floor;
            if (field === 'bedrooms' && data.bedrooms != null) unit.bedrooms = data.bedrooms;
            if (field === 'bathrooms' && data.bathrooms != null) unit.bathrooms = data.bathrooms;
          }
          this.cancelInlineEdit();
          this.syncUnitsDataToParent();
        },
        error: (error) => {
          this.cancelInlineEdit();
          const rawMessage = error?.error?.message;
          const key = typeof rawMessage === 'string' ? rawMessage : rawMessage?.message;
          const translated = typeof key === 'string' && key.startsWith('t-')
            ? this.translateService.instant(key)
            : null;
          this.errorMsg(
            translated && translated !== key
              ? translated
              : this.translateService.instant('t-error-updating')
          );
        }
      });
  }

  private normalizeInlineValue(field: InlineUnitField, raw: any): any {
    const text = raw === null || raw === undefined ? '' : `${raw}`.trim();
    switch (field) {
      case 'propertyType':
        return raw === null || raw === undefined || raw === '' ? undefined : raw;
      case 'floor':
        return text === '' ? null : text;
      case 'price':
      case 'grossArea': {
        if (text === '') return null;
        const num = Number(text.replace(/\s/g, '').replace(',', '.'));
        return Number.isFinite(num) && num >= 0 ? num : undefined;
      }
      case 'bedrooms':
      case 'bathrooms': {
        if (text === '') return 0;
        const num = Number(text);
        return Number.isInteger(num) && num >= 0 ? num : undefined;
      }
      default:
        return undefined;
    }
  }

  private isSameInlineValue(a: any, b: any): boolean {
    const emptyA = a === null || a === undefined || a === '';
    const emptyB = b === null || b === undefined || b === '';
    if (emptyA && emptyB) return true;
    if (emptyA !== emptyB) return false;
    const numA = Number(a);
    const numB = Number(b);
    if (Number.isFinite(numA) && Number.isFinite(numB)) {
      return numA === numB;
    }
    return `${a}` === `${b}`;
  }

  private applyInlineValue(unit: UnitsModel | any, field: InlineUnitField, value: any) {
    if (field === 'propertyType') {
      unit.propertyTypeId = value;
      const found = this.propertyTypes?.find((pt: any) => pt.id == value);
      if (found?.description) unit.propertyType = found.description;
      return;
    }
    unit[field] = value;
  }

  /** Mesmo sync que o evento 'get-data-tab-units': o pai fica com as listas atuais. */
  private syncUnitsDataToParent() {
    if (this.typeSelected?.id === 1) {
      this.unitsData = this.dataFractions;
    } else if (this.typeSelected?.id === 2) {
      this.unitsData = this.dataBlocks;
    }
    this.unitsDataChange.emit(this.unitsData);
  }

  canToggleFractionStatus(fraction?: any) {
    return (
      !!fraction &&
      !fraction.isNew &&
      !fraction.isToggling &&
      this.propertyUpdate?.status === true &&
      this.canManageUnit(fraction)
    );
  }

  toggleFractionStatus(fraction: any) {
    if (!this.canToggleFractionStatus(fraction)) return;

    fraction.isToggling = true;

    this.propertiesService.toggleUnitActiveStatus(fraction.id)
      .pipe(finalize(() => fraction.isToggling = false))
      .subscribe({
        next: (data: any) => {
          fraction.status = data?.status === true;
        },
        error: (error) => {
          const message = error?.error?.message;
          this.errorMsg(
            message === 't-development-not-active'
              ? this.translateService.instant('t-developments.t-development-not-active')
              : this.translateService.instant('t-developments.t-unit-status-toggle-error')
          );
        }
      });
  }

  duplicateFraction(fraction: UnitsModel, blockId: any = null) {
    if (!fraction || fraction.isDuplicating || !this.canManageUnit(fraction)) return;

    if (fraction.isNew) {
      this.duplicateLocalFraction(fraction, blockId);
      return;
    }

    const swalOptions: any = {
      title: this.translateService.instant('t-duplicate-property'),
      text: this.translateService.instant('t-duplicate-property-question'),
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: 'rgb(54, 69, 116)',
      confirmButtonText: this.translateService.instant('t-duplicate'),
      cancelButtonText: this.translateService.instant('t-cancel'),
    };

    Swal.fire(swalOptions).then(result => {
      if (!result.value) return;

      fraction.isDuplicating = true;

      this.propertiesService.duplicateProperty(fraction.id)
        .pipe(
          switchMap((data) => this.propertiesService.getUnitById(data.resId)),
          finalize(() => fraction.isDuplicating = false)
        )
        .subscribe({
          next: (duplicatedUnit: any) => {
            this.addDuplicatedFractionToList(
              this.normalizeUnitForList(duplicatedUnit),
              blockId,
            );
            Swal.fire(
              this.translateService.instant('t-property-duplicated'),
              this.translateService.instant('t-property-duplicated-successfully'),
              'success'
            );
          },
          error: (error) => {
            const message = error?.error?.message;
            this.errorMsg(
              message === 'Reference already exists'
                ? this.translateService.instant('t-m-properties.t-this-reference-has-already-been-used')
                : this.translateService.instant('t-property-duplicate-error')
            );
          },
        });
    });
  }

  /**
   * "Criar revenda": a fração (já gravada) é duplicada como imóvel comum
   * com o seu tipo real. O resultado não é uma fração, por isso não entra
   * nesta lista: a lista de imóveis é avisada e o Swal mostra a referência.
   */
  createResale(fraction: UnitsModel) {
    if (!fraction?.id || fraction.isNew || fraction.isCreatingResale || !this.canManageUnit(fraction)) return;

    const isAutoReference = !!this.checkAutoRef;
    const swalOptions: any = {
      title: this.translateService.instant('t-create-resale'),
      html: this.buildResaleExplanationHtml(fraction),
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: 'rgb(54, 69, 116)',
      confirmButtonText: this.translateService.instant('t-create-resale'),
      cancelButtonText: this.translateService.instant('t-cancel'),
    };

    if (!isAutoReference) {
      swalOptions.input = 'text';
      swalOptions.inputLabel = this.translateService.instant('t-m-properties.t-reference');
      swalOptions.inputValidator = (value: string) => {
        if (!value?.trim()) {
          return this.translateService.instant('t-reference-error-required');
        }
        return null;
      };
    }

    Swal.fire(swalOptions).then(result => {
      if (!result.value) return;

      const reference = isAutoReference ? undefined : `${result.value}`.trim();

      fraction.isCreatingResale = true;
      this.propertiesService.createResale(fraction.id, reference)
        .pipe(finalize(() => fraction.isCreatingResale = false))
        .subscribe({
          next: (data: any) => {
            if (data?.resId) this.eventService.broadcast('new-property-created', data.resId);
            this.eventService.broadcast('refresh-properties');
            Swal.fire(
              this.translateService.instant('t-resale-created'),
              `${this.translateService.instant('t-resale-created-successfully')}${data?.ref ? ` (${data.ref})` : ''}`,
              'success'
            );
          },
          error: (error) => {
            const message = `${error?.error?.message ?? ''}`;
            this.errorMsg(
              message === 'Reference already exists'
                ? this.translateService.instant('t-m-properties.t-this-reference-has-already-been-used')
                : message.startsWith('t-resale-')
                  ? this.translateService.instant(message)
                  : this.translateService.instant('t-resale-create-error')
            );
          },
        });
    });
  }

  /**
   * Texto da confirmação de "Criar revenda": o que vai acontecer (imóvel
   * novo, sem ligação ao empreendimento, o que é copiado, estado inicial),
   * para o utilizador ter a certeza antes de avançar.
   */
  private buildResaleExplanationHtml(fraction: UnitsModel): string {
    const escape = (value: any) =>
      `${value ?? ''}`.replace(/[&<>"']/g, (c) =>
        ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string)
      );
    const t = (key: string, params?: any) => escape(this.translateService.instant(key, params));
    // `propertyType` da linha já é o tipo real da fração (propertyTypeId2).
    const typeName = typeof fraction?.propertyType === 'string' ? fraction.propertyType : '';
    const reference = fraction?.reference ?? '';

    const points = [
      typeName
        ? t('t-create-resale-point-type', { type: typeName })
        : t('t-create-resale-point-type-unknown'),
      t('t-create-resale-point-not-associated'),
      t('t-create-resale-point-copied'),
      t('t-create-resale-point-status'),
    ];

    return `
      <div class="text-start fs-14">
        <p class="mb-2">${t('t-create-resale-intro', { reference })}</p>
        <ul class="ps-3 mb-3">${points.map((point) => `<li class="mb-1">${point}</li>`).join('')}</ul>
        <p class="mb-0 fw-semibold">${t('t-create-resale-question')}</p>
      </div>`;
  }

  private normalizeUnitForList(unit: UnitsModel): UnitsModel {
    const propertyTypeId = unit?.propertyTypeId ?? unit?.propertyType;

    return {
      ...unit,
      propertyTypeId,
      propertyType: this.propertyTypes.find((pt: any) => pt.id == propertyTypeId)?.description ?? unit?.propertyType,
    };
  }

  private duplicateLocalFraction(fraction: UnitsModel, blockId: any = null) {
    const duplicatedFraction: UnitsModel = {
      ...fraction,
      id: this.createLocalFractionId(),
      title: fraction.title?.map(title => ({ ...title })) || [],
      reference: undefined,
      isNew: true,
      isDuplicating: false,
      changeBlock: undefined,
    };

    this.addDuplicatedFractionToList(duplicatedFraction, blockId);
  }

  private createLocalFractionId() {
    return `new-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
  }

  private addDuplicatedFractionToList(fraction: UnitsModel, blockId: any = null) {
    if (this.typeSelected?.id === 1) {
      this.dataFractions.push(fraction);
      this.unitsData = this.dataFractions;
      this.refreshPagination(this.dataFractions);
      this.unitsDataChange.emit(this.unitsData);
      return;
    }

    const block = this.dataBlocks.find(b => b.id === blockId);
    const blockBkp = this.blocksBkp.find(b => b.id === blockId);

    if (block) {
      block.units = [...(block.units || []), fraction];
    }

    if (blockBkp && blockBkp !== block) {
      blockBkp.units = [...(blockBkp.units || []), fraction];
    }

    this.unitsData = this.blocksBkp;
    if (this.openedDropdown) {
      const openedBlock = this.blocksBkp.find(b => b.id === this.openedDropdown);
      if (openedBlock)
        this.refreshPagination(openedBlock.units);
    }
    this.unitsDataChange.emit(this.unitsData);
  }

  editFraction(fraction: UnitsModel, content: any) {
    if (fraction.isNew) {
      this.fractionUpdated = fraction;
      this.initFormFraction(fraction);
      let modal = this.modalService.open(content, { size: 'md', centered: true, backdropClass: 'custom-modal' });
      modal.closed.subscribe(() => {
        this.fractionUpdated = null;
        this.fractionForm.reset();
      });
      modal.dismissed.subscribe(() => {
        this.fractionUpdated = null;
        this.fractionForm.reset();
      });
    } else if (this.isPersistedFraction(fraction)) {
      this.eventService.broadcast('open-fraction-by-dev', fraction.id);
    }
  }

  viewFraction(fraction: UnitsModel) {
    // Fracoes ainda nao gravadas tem um id local ("new-..."), que o back-end
    // nao consegue ler como UUID. So ha pre-visualizacao depois de gravar.
    if (!this.isPersistedFraction(fraction)) return;
    this.eventService.broadcast('open-fraction-by-dev', fraction.id);
  }

  isPersistedFraction(fraction: UnitsModel | any): boolean {
    return !fraction?.isNew && !!fraction?.id && !`${fraction.id}`.startsWith('new-');
  }

  deleteFraction(fraction: UnitsModel, blockId: any) {
    Swal.fire({
      title: this.translateService.instant('t-m-properties.t-are-you-sure-you-want-to-delete-the-property'),
      //text: 'Deleting your user will remove all of your information from our database.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f46a6a',
      confirmButtonText: this.translateService.instant('t-yes'),
      cancelButtonText: this.translateService.instant('t-cancel')
    }).then(result => {
      if (result.value) {
        if (fraction.isNew) {
          if (this.dataFractions) {
            this.dataFractions = this.dataFractions.filter(f => f.id !== fraction.id);
          }
          if (this.dataBlocks || this.blocksBkp) {
            const find = this.dataBlocks.find(block => block.id === blockId);
            const findBkp = this.blocksBkp.find(block => block.id === blockId);
            if (find) {
              find.units = find.units.filter(u => u.id !== fraction.id)
            }
            if (findBkp) {
              findBkp.units = findBkp.units.filter(u => u.id !== fraction.id)
            }
          }

          if (this.typeSelected?.id === 1) {
            this.unitsData = this.dataFractions;
            this.refreshPagination(this.dataFractions);
          } else if (this.typeSelected?.id === 2) {
            this.unitsData = this.blocksBkp;
            if (this.openedDropdown) {
              const block = this.blocksBkp.find(b => b.id === this.openedDropdown);
              if (block)
                this.refreshPagination(block.units);
            }
          }
          this.unitsDataChange.emit(this.unitsData);

          Swal.fire(
            this.translateService.instant('t-m-properties.t-deleted'),
            this.translateService.instant('t-m-properties.t-properties-have-been-successfully-deleted'),
            'success');
        } else {
          this.propertiesService.deleteByIds([fraction.id]).subscribe(
            () => {
              if (this.dataFractions) {
                this.dataFractions = this.dataFractions.filter(f => f.id !== fraction.id);
              }
              if (this.dataBlocks) {
                const find = this.dataBlocks.find(block => block.id === blockId);
                if (find) {
                  find.units = find.units.filter(u => u.id !== fraction.id)
                }
                const findBkp = this.blocksBkp.find(block => block.id === blockId);
                if (findBkp) {
                  findBkp.units = findBkp.units.filter(u => u.id !== fraction.id)
                }
              }

              if (this.typeSelected?.id === 1) {
                this.unitsData = this.dataFractions;
                this.refreshPagination(this.dataFractions);
              } else if (this.typeSelected?.id === 2) {
                this.unitsData = this.dataBlocks;
                if (this.openedDropdown) {
                  const block = this.dataBlocks.find(b => b.id === this.openedDropdown);
                  if (block)
                    this.refreshPagination(block.units);
                }
              }
              this.unitsDataChange.emit(this.unitsData);

              Swal.fire(
                this.translateService.instant('t-m-properties.t-deleted'),
                this.translateService.instant('t-m-properties.t-properties-have-been-successfully-deleted'),
                'success');
            },
            error => {
              // console.error(error);
              this.errorMsg(this.translateService.instant('t-m-properties.t-at-the-moment-it-is-not-possible-to-delete-the-property'));
            }
          );
        }
      }
    });
  }

  onChangeBlock(event: any, property: UnitsModel, oldBlock: BlockModel) {
    if (event?.target?.value) {
      const newBlock = this.blocksBkp.find(b => b.id == event?.target?.value);
      if (newBlock) {
        if (newBlock.isNew) {
          oldBlock.units = oldBlock.units.filter(u => u.id != property?.id);
          newBlock.units.push(property);
          if (this.openedDropdown && this.openedDropdown === oldBlock.id) {
            this.refreshPagination(oldBlock.units);
          }
        } else {
          if (property?.isNew) {
            oldBlock.units = oldBlock.units.filter(u => u.id != property?.id);
            newBlock.units.push(property);
            if (this.openedDropdown && this.openedDropdown === oldBlock.id) {
              this.refreshPagination(oldBlock.units);
            }
          } else {
            property.changeBlock = true;
            oldBlock.units = oldBlock.units.filter(u => u.id != property?.id);
            newBlock.units.push(property);
            if (this.openedDropdown && this.openedDropdown === oldBlock.id) {
              this.refreshPagination(oldBlock.units);
            }
          }
        }
      }
    }
  }

  /**
 * Title sweet alert
 * @param errorMsg Msg modal content
 */
  errorMsg(errorMsg: string) {
    Swal.fire({
      title: 'Oops...! Something went Wrong !',
      text: errorMsg,
      icon: 'warning',
      confirmButtonColor: 'rgb(54, 69, 116)',
      confirmButtonText: 'Close'
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    if (this.typeSelected?.id === 1) {
      this.unitsData = this.dataFractions;
    } else if (this.typeSelected?.id === 2) {
      this.unitsData = this.dataBlocks;
    }
    this.unitsDataChange.emit(this.unitsData);
  }
}
